import * as swcHelpers from '@swc/helpers';
import { takeLatest, select, call, put } from 'redux-saga/effects';
import { toast } from '@grandvisionhq/common';
import { optIns } from '../customer-service.js';
import { getAuth, getChangedOptIns } from '../selectors.js';
import { isLoggedIn } from '../state.js';
import { createOptInsUpdate } from '../Util/create-opt-in-updates.js';
import { FETCH_OPT_INS, UPDATE_OPT_INS, fetchOptInsSuccess, fetchOptInsFailed, updateOptInsSuccess, updateOptInsFailed } from './actions.js';

/** @deprecated use the new GQL hook use-opt-ins.ts */ function* fetchOptIns() {
    try {
        const auth = yield select(getAuth);
        if (!isLoggedIn(auth)) {
            throw new Error(`Can't fetch opt-ins when user isn't logged in`);
        }
        const result = yield call([
            optIns,
            'fetch'
        ], auth.apiUrl, auth.userId);
        yield put(fetchOptInsSuccess(result));
    } catch (err) {
        yield put(fetchOptInsFailed(err));
    }
}
/** @deprecated use the new GQL hook use-opt-ins.ts */ function* updateOptIns(action) {
    try {
        const auth = yield select(getAuth);
        if (!isLoggedIn(auth)) {
            throw new Error(`Can't fetch opt-ins when user isn't logged in`);
        }
        /**
     * This saga handles 2 scenarios:
     *  1. Changed opt-ins are coming from outside the auth state, so they are passed as payload of the action
     *  2. Changed opt-ins are set within the auth state, meaning we can use a selector to grab them from the state
     */ let changedOptIns = action.payload;
        if (changedOptIns === undefined) {
            changedOptIns = yield select(getChangedOptIns);
        }
        // Convert to opt-in update model
        const updates = yield call(createOptInsUpdate, changedOptIns);
        if (Object.keys(updates).length > 0) {
            // Get opt-ins state from server
            const serverOptInsState = yield call([
                optIns,
                'fetch'
            ], auth.apiUrl, auth.userId);
            // Diff what is actually an opt-in update
            const diff = Object.entries(updates).reduce((acc, [key, optIn])=>(serverOptInsState.optinValues || {})[key] !== optIn.value ? swcHelpers.objectSpread({}, acc, {
                    [key]: optIn
                }) : acc
            , {});
            if (Object.keys(diff).length > 0) {
                yield call([
                    optIns,
                    'update'
                ], auth.apiUrl, auth.userId, diff);
            }
            yield put(updateOptInsSuccess());
            yield call(toast.success, 'account.updateOptins.success');
        }
    } catch (err) {
        yield put(updateOptInsFailed(err));
    }
}
/** @deprecated use the new GQL hook use-opt-ins.ts */ var optInSagas = [
    takeLatest(FETCH_OPT_INS, fetchOptIns),
    takeLatest(UPDATE_OPT_INS, updateOptIns), 
];

export { optInSagas as default, fetchOptIns, updateOptIns };
//# sourceMappingURL=sagas.js.map
